import { Button, Col, Container, Form, Row } from "react-bootstrap";
import DependantHeaderSample from "../common/dependantHeaderSample";
import { useEffect, useState } from "react";
import { _axios } from "../../plugins/axios";
import { URL, platform } from "../../constants/constant";
import PackageInfo from "./packageInfo";
import { useHistory } from "react-router-dom";
import { TextField } from "@mui/material";
import repository from "../../repository/repository";
import AHCCarousel from "./ahcCard";

const PackageSelection = () => {
	const userName = localStorage.getItem("userName");
	const selectedBenef = JSON.parse(localStorage.getItem("selectedBenef"));
	const parentOrderDetails = localStorage.getItem("parentOrderDetails")
		? JSON.parse(localStorage.getItem("parentOrderDetails"))
		: null;
	const [pincode, setPincode] = useState(
		parentOrderDetails && parentOrderDetails.pincode
			? parentOrderDetails.pincode
			: "",
	);
	const [city, setCity] = useState(
		parentOrderDetails && parentOrderDetails.city
			? parentOrderDetails.city
			: "",
	);
	const [allPackages, setAllPackages] = useState([]);
	const [listingPackageOptions, setListingPackageOptions] = useState([]);
	const [listingPackages, setListingPackages] = useState([]);
	const [cart, setCart] = useState([]);
	const [showPackageInfo, setShowPackageInfo] = useState(false);
	const [packageIdToShowInfo, setPackageIdToShowInfo] = useState();
	const [packageNameToShowInfo, setPackageNameToShowInfo] = useState();
	const [searchText, setSearchText] = useState("");
	const [searchPackages, setSearchPackages] = useState([]);
	const [searchPackageOptions, setSearchPackageOptions] = useState([]);
	const [showPackageOptions, setShowPackageOptions] = useState(false);
	const [ahcPackages, setAhcPackages] = useState([]);
	const history = useHistory();
	const fetchPackages = async () => {
		try {
			let accessToken = localStorage.getItem("user_short_token");
			let url = URL.dev_url + "packages-listing";
			let obj = {
				pincode: pincode,
				contractIds: [10389, 10386],
			};
			let headers = {
				usertoken: accessToken,
				platform: platform,
				pincode: pincode,
			};
			let response = await _axios.post(url, obj, { headers: headers });
			if (response.data.isSuccess) {
				let packages = response.data.packages;
				packages.sort((a, b) => a.price - b.price);
				let options = [];
				packages.forEach((i) => {
					let obj = {
						value: i.packageId,
						label: i.packageName + " (" + i.packageDisplayName + ")",
					};
					options.push(obj);
				});
				localStorage.setItem("selectedProviderId", response.data.providerId);
				setCity(response.data.city);
				setListingPackageOptions(options);
				setSearchPackageOptions(options);
				setSearchPackages(packages);
				setListingPackages(packages);
				setAllPackages(packages);
			}
		} catch (error) {
			alert(
				error.response?.data?.message ??
					"Something went wrong. Please try again",
			);
		}
	};

	const fetchCorporatePackages = async () => {
		const accesstoken = localStorage.getItem("user_short_token");
		let packages = [];
		try {
			const selectedProviderId = JSON.parse(localStorage.getItem("selectedProviderId"));
			const response = await repository.fetchCorporatePackages(accesstoken, city, pincode, platform, selectedProviderId);
			const employeeDetails = response.employeeDetail;
			packages = employeeDetails.beneficiaries.find((i) => i.maid == selectedBenef.maid)?.packages;
		} catch (error) {	
			console.log(error);
		} finally {
			const filteredPackages = filterAHCPackages(packages);
			filteredPackages?.forEach((item) => {
				item.isAddToCartDisabled = false;
			});
			setAhcPackages(filteredPackages);
		}
	};

	const handlePackageChange = (selectedOption) => {
		let reqPackage = allPackages.filter(
			(pack) => pack.packageId == selectedOption.value,
		);
		setSearchPackages(reqPackage);
		setShowPackageOptions(false);
	};

	const addRemoveToCart = (packageId, packageName, price, contractId) => {
		let tempCart = [...cart];
		if (tempCart.some((item) => item.packageId == packageId)) {
			let index = tempCart.findIndex((item) => item.packageId == packageId);
			tempCart.splice(index, 1);
			setCart(tempCart);
		} else {
			let obj = {
				packageId: packageId,
				packageName: packageName,
				price: price,
				contractId: contractId,
			};
			tempCart.push(obj);
			setCart(tempCart);
		}

		handleAHCPackgeCartAction(tempCart, packageId);
	};

	const viewDetails = (packageId, packageName) => {
		setPackageIdToShowInfo(packageId);
		setPackageNameToShowInfo(packageName);
		setShowPackageInfo(true);
	};

	const moveToCheckout = () => {
		localStorage.setItem("cart", JSON.stringify(cart));
		if (!parentOrderDetails) {
			localStorage.setItem(
				"parentOrderDetails",
				JSON.stringify({
					pincode: pincode,
					city: city,
				}),
			);
		}
		history.push("/checkout");
	};

	const contractFilterApply = (contract) => {
		let filterPackages = allPackages.filter(
			(pkg) => pkg.contractId == contract,
		);
		setSearchPackages(filterPackages);
	};

	const genderFilterApply = (gender) => {
		let filterPackages = allPackages.filter((pkg) => pkg.gender == gender);
		setSearchPackages(filterPackages);
	};

	const removeFilters = () => {
		setSearchPackages(allPackages);
	};

	const searchItems = async (query) => {
		try {
			const providerId = parseInt(localStorage.getItem("selectedProviderId"));
			const accessToken = localStorage.getItem("user_short_token");
			const res = await repository.searchItems(city, pincode, providerId, query, accessToken);
			if (!res.data.isSuccess) throw new Error(res.data.errorMessage);

			const searchedItems = res.data.searchedItems;
			const pkgOptions = searchedItems.map((i) => {
				return {
					value: i.packageId,
					label: i.packageName + " (" + i.packageDisplayName + ")",
				};
			});
			setSearchPackages(searchedItems);
			setAllPackages(searchedItems);
			setSearchPackageOptions(pkgOptions);
		} catch (error) {
			alert(error?.message ?? "Something went wrong. Please try again");
		}
	};

	const handleSearchTextChange = (evt) => {
		setSearchText(evt.target.value);
		setSearchPackageOptions([]);
	};

	const fetchAllPackages = async () => {
		await fetchPackages();
		await fetchCorporatePackages();
	};

	const filterAHCPackages = (packages) => {
		if (!packages?.length) return [];

		let filteredPackages = packages;
		
		// filtered home visit packages and sponsored packages
		filteredPackages = packages.filter(
			(pkg) => pkg.isSponsored &&
				pkg.visitType.length == 1 &&
				pkg.visitType.includes("HomeVisit")
		);

		return filteredPackages;
	};

	const handleAHCPackgeCartAction = (tempCart, packageId) => {
		// Check if the current package is an AHC package
		const isAHCPackage = ahcPackages.some((pkg) => pkg.packageId == packageId);

		if (isAHCPackage) {
			// Check if any AHC package is now in the cart
			const hasAHCPackageInCart = tempCart.some((cartItem) =>
				ahcPackages.some((pkg) => pkg.packageId == cartItem.packageId)
			);

			if (hasAHCPackageInCart) {
				// Disable all AHC packages except the one in cart
				const ahcPackageInCart = tempCart.find((cartItem) =>
					ahcPackages.some((pkg) => pkg.packageId == cartItem.packageId)
				);

				ahcPackages.forEach((pkg) => {
					pkg.isAddToCartDisabled = pkg.packageId !== ahcPackageInCart.packageId;
				});
			} else {
				// Enable all AHC packages if none in cart
				ahcPackages.forEach((pkg) => {
					pkg.isAddToCartDisabled = false;
				});
			}
			setAhcPackages([...ahcPackages]);
		}
	}

	useEffect(() => {
		if (!searchText.length) {
			setSearchPackageOptions(listingPackageOptions);
			setSearchPackages(listingPackages);
			setAllPackages(listingPackages);
			return;
		}

		const debouce = setTimeout(() => {
			searchItems(searchText);
		}, 700);

		return () => clearTimeout(debouce);
	}, [searchText]);

	return (
		<div className="order-details-dashboard p-b-10">
			<div>
				<div className="header-sample">
					<i
						className="fa fa-chevron-circle-left"
						onClick={() => history.push("/labs/userBenefits")}
					></i>
				</div>
				<DependantHeaderSample
					titleCall={true}
					noCall={true}
					title="Create Order"
				></DependantHeaderSample>
			</div>
			<div>
				<Container className="p-t-10 p-b-10">
					<Row>
						<Col>
							<div className="font-size-smd">
								<b>Username:</b> {userName}
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="font-size-smd">
								<b>Relation:</b> {selectedBenef.relationName}
							</div>
							<div className="font-size-smd">
								<b>Name:</b> {selectedBenef.name}
							</div>
						</Col>
					</Row>
					<Form onSubmit={(e) => fetchAllPackages()} className="m-t-10">
						<Row>
							<Col xs={6} md={6}>
								<Form.Group className="mb-3" controlId="Pincode">
									<Form.Control
										type="text"
										placeholder="Enter Pincode"
										onChange={(e) => setPincode(e.target.value)}
										disabled={parentOrderDetails && parentOrderDetails.pincode}
										value={pincode}
									/>
								</Form.Group>
							</Col>
							<Col xs={6} md={6}>
								<Form.Group className="mb-3" controlId="City">
									<Form.Control
										type="text"
										placeholder="Enter City"
										onChange={(e) => setCity(e.target.value)}
										disabled={true}
										value={city}
									/>
								</Form.Group>
							</Col>
						</Row>
						<Button
							variant="primary"
							type="submit"
							disabled={!pincode}
							className="text-align-center w-100"
						>
							Fetch Tests/Packages
						</Button>
						<hr />
					</Form>

					{ahcPackages?.length > 0 && (
						<AHCCarousel
							ahcPackages={ahcPackages}
							cart={cart}
							addRemoveToCart={addRemoveToCart}
							viewDetails={viewDetails}
						/>
					)}

					{listingPackages.length > 0 && (
						<div>
							<div className="m-15">
								<Row>
									Filters:
									<div
										className="m-l-5 m-r-5 btn btn-outline-primary"
										style={{ padding: "5px" }}
										type="submit"
										size="sm"
										onClick={() => contractFilterApply(10386)}
									>
										Packages
									</div>
									<div
										className="m-r-5 btn btn-outline-primary"
										style={{ padding: "5px" }}
										type="submit"
										size="sm"
										onClick={() => contractFilterApply(10389)}
									>
										Tests
									</div>
									<button
										className="m-r-5 btn btn-outline-primary"
										style={{ padding: "5px" }}
										type="submit"
										size="sm"
										onClick={() => genderFilterApply("Male")}
									>
										Male
									</button>
									<button
										className="m-r-5 btn btn-outline-primary"
										style={{ padding: "5px" }}
										type="submit"
										size="sm"
										onClick={() => genderFilterApply("Female")}
									>
										Female
									</button>
									<button
										className="m-r-5 btn btn-outline-primary"
										style={{ padding: "5px" }}
										type="submit"
										size="sm"
										onClick={() => genderFilterApply("Both")}
									>
										Both
									</button>
									<button
										className="m-r-5 btn btn-outline-primary"
										style={{ padding: "5px" }}
										type="submit"
										size="sm"
										onClick={() => removeFilters()}
									>
										None
									</button>
								</Row>
							</div>
							<Row>
								<Col>
									<div className="font-size-md">
										<b>Package List</b>
									</div>
								</Col>
							</Row>

							<TextField
								label="Search"
								type="text"
								className="w-100"
								variant="outlined"
								style={{ marginTop: "5px" }}
								onChange={(evt) => handleSearchTextChange(evt)}
								onFocus={() => setShowPackageOptions(true)}
								onBlur={() => setShowPackageOptions(false)}
							/>
						</div>
					)}

					{showPackageOptions && (
						<div
							className="overflow-scroll p-10"
							style={{
								maxHeight: "35vh",
								width: "85vw",
								background: "white",
								position: "absolute",
								zIndex: 20,
							}}
						>
							{searchPackageOptions &&
								searchPackageOptions.map((elem, index) => (
									<p onMouseDown={() => handlePackageChange(elem)}>
										{elem.label}
									</p>
								))}
						</div>
					)}

					{listingPackages.length > 0 &&
						(searchPackages?.length ? (
							searchPackages.map((elem, index) => {
								return (
									<div
										key={index}
										className="card-box font-size-smd p-10 m-t-10 m-b-10"
										style={{ boxShadow: "2px 2px 4px 2px rgba(0, 0, 0, 0.2)" }}
									>
										<div className="font-size-md">
											<b>{elem.packageName}</b>
										</div>
										<div className="font-size-smd m-t-10">
											<b>Display Name: </b> {elem.packageDisplayName}
										</div>
										<div className="font-size-smd">
											<b>Gender: </b> {elem.gender}
										</div>
										<div className="font-size-smd">
											<b>Age Range: </b> {elem.minAge} - {elem.maxAge}
										</div>
										<div className="font-size-smd">{elem.testCount} Tests</div>
										<div className="font-size-md">
											<b>Price: INR {elem.price}</b>
										</div>
										<Row className="m-t-10">
											<Col xs={6} md={6}>
												<Button
													variant="primary"
													type="submit"
													className="text-align-center w-100"
													onClick={() =>
														viewDetails(elem.packageId, elem.packageName)
													}
												>
													View Details
												</Button>
											</Col>
											<Col xs={6} md={6}>
												<Button
													variant="primary"
													type="submit"
													className="text-align-center w-100"
													onClick={() =>
														addRemoveToCart(
															elem.packageId,
															elem.packageName,
															elem.price,
															elem.contractId,
														)
													}
												>
													{cart.some((item) => item.packageId == elem.packageId)
														? "Remove"
														: "Add"}
												</Button>
											</Col>
										</Row>
									</div>
								);
							})
						) : (
							<div className="p-10 m-t-10 m-b-10">
								<p> No Packages found </p>
							</div>
						))}
				</Container>
			</div>
			<Container>
				<div className="fixed-bottom p-l-15 p-r-15 p-t-5">
					<Row>
						<Col xs={6}>{cart.length} in Cart</Col>
						<Col xs={6}>
							<Button
								variant="primary"
								size="md"
								block
								className="border-curve-10"
								disabled={!cart.length}
								onClick={() => moveToCheckout()}
							>
								Proceed
							</Button>
						</Col>
					</Row>
				</div>
			</Container>
			{showPackageInfo && (
				<PackageInfo
					showPackageInfo={showPackageInfo}
					setShowPackageInfo={setShowPackageInfo}
					packageId={packageIdToShowInfo}
					packageName={packageNameToShowInfo}
					pincode={pincode}
					city={city}
				/>
			)}
		</div>
	);
};

export default PackageSelection;
